import { actions } from './service/actions'
import { getters } from './service/getters'
import { state } from './service/state'
import { mutations } from './service/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
